export default __webpack_public_path__ + "static/media/Version (4) - Half-Blood Prince - Thumbnail.6afc95d3.png";